"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    theme: _propTypes.string,
    onChange: _propTypes.func,
    minValue: _propTypes.number,
    maxValue: _propTypes.number,
    defaultValue: _propTypes.number,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    color: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    emptyAreaColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    filterData: _propTypes.object,
    hideHeaderTitle: _propTypes.bool,
    displayBottomSliderLabel: _propTypes.bool,
    currency: _propTypes.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    onChange: function onChange() {},
    minValue: _constant2.RANGE_SLIDER_VALUES.MIN,
    maxValue: _constant2.RANGE_SLIDER_VALUES.MAX,
    defaultValue: _constant2.RANGE_SLIDER_VALUES.DEFAULT_VALUE,
    accessible: true,
    color: 'primary',
    emptyAreaColor: 'greyLight',
    hideHeaderTitle: false,
    displayBottomSliderLabel: false
  }
};
exports.default = _default;